var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClubDefaultIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.674805,
    width: 36,
    height: 36,
    rx: 3,
    fill: "#EDEDED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 10.6748V8.6748H13V10.6748H10V28.6748H16V26.6748H20V28.6748H26V10.6748H23ZM17 23.6748H15V21.6748H17V23.6748ZM17 19.6748H15V17.6748H17V19.6748ZM17 15.6748H15V13.6748H17V15.6748ZM21 23.6748H19V21.6748H21V23.6748ZM21 19.6748H19V17.6748H21V19.6748ZM21 15.6748H19V13.6748H21V15.6748Z",
    fill: "#ADADAD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClubDefaultIcon);
export default __webpack_public_path__ + "static/media/club-default-icon.1f3688ad9fac83c2ee3d399ffbe1fa25.svg";
export { ForwardRef as ReactComponent };